/**
 * Styled components for Gate Deviation Dialog
 */

import styled from 'styled-components/macro';
import { DialogBody } from '@blueprintjs/core-modern';

export const StyledDialogBody = styled(DialogBody).attrs({
  className: 'gate-deviation-dialog__body',
})`
  display: flex;
  flex-direction: column;
  min-height: 700px;
  max-height: 70vh;
`;

/** Wraps dialog body content so the chart area can flex and fill remaining height */
export const ChartBodyWrapper = styled.div.attrs({
  className: 'gate-deviation-dialog__chart-body-wrapper',
})`
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  max-height: 70vh;

  & > * {
    min-height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;

/** Flex column container for chart + legend; fills GraphLoading child */
export const ChartContainer = styled.div.attrs({
  className: 'gate-deviation-dialog__chart-container',
})`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

/** Chart area that grows to fill space; contains Scatter and tooltips */
export const ChartArea = styled.div.attrs({
  className: 'gate-deviation-dialog__chart-area',
})`
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  position: relative;
  width: 100%;
`;

/** Wrapper for Chart.js canvas so it fills ChartArea */
export const ChartInner = styled.div.attrs({
  className: 'gate-deviation-dialog__chart-inner',
})`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
`;

/** Zoom controls (reset, in, out) floated over the chart in the bottom-right corner */
export const ChartZoomControlsOverlay = styled.div.attrs({
  className: 'gate-deviation-dialog__chart-zoom-controls',
})`
  position: absolute;
  bottom: 12px;
  right: 12px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  z-index: 1;

  & .bp5-button {
    min-height: 20px;
    min-width: 20px;
    padding: 2px 6px;
    font-size: 12px;
  }

  & .bp5-icon {
    width: 16px;
    height: 16px;
  }
`;

/** Legend and zoom hint; does not shrink */
export const ChartFooter = styled.div.attrs({
  className: 'gate-deviation-dialog__chart-footer',
})`
  flex-shrink: 0;
`;

export const ZoomHint = styled.p.attrs({
  className: 'gate-deviation-dialog__zoom-hint',
})`
  font-size: 12px;
  color: #666;
  text-align: left;
  margin-top: 1rem;
  padding-left: 55px;
`;

/** Footer row: left button group | right button group */
export const DialogFooterRow = styled.div.attrs({
  className: 'gate-deviation-dialog__footer-row',
})`
  display: flex;
  justify-content: space-between;
`;

export const DialogFooterButtonGroup = styled.div.attrs({
  className: 'gate-deviation-dialog__footer-button-group',
})`
  display: flex;
  gap: 8px;
`;
